<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="CHAPTER1" id="uy8ITfFKzdr8ZMHWQnav98F" lang="en-US"><span class="Basic_Bold"><a id="uTpbrA5J7bWWa7Jt4wPvNRB"></a>PROLOGUE</span></p>
<p class="FIRSTPARAGRAPH _idGenParaOverride-1" lang="en-US"><span class="Basic_italics"><a id="u9YvNxc7i2HZa5ZeL6MJom4"></a>I sit behind bars an innocent man. I sit behind bars condemned by public opinion. I sit behind bars condemned of murder of innocent children. I sit behind bars condemned by a psychologist who has never met me, of being an “unfeeling animal!” I sit behind bars listening to all they say about me on the outside and ask my Lord “why”!</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Prologue.vue?6f113a0d